var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-by-step button is-small",on:{"click":function($event){$event.stopPropagation();_vm.$root.$emit('instruction-step-by-step')}}},[(_vm.isMobile)?_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-expand"})]):_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92ef6510","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/recipe/InstructionStepByStep.vue
// module id = 1179
// module chunks = 0